import OBase from './OBase';
import * as Geometry from '../geometry';

export default class CullIndex extends OBase {
  update () {
    let lInputTree = this.getObjectInput('List');
    let iInputTree = this.getFloatInput('Indices');
    let wInputTree = this.getBoolInput('Wrap');

    let output = this.outputs['List'].paramObject;

    let dataTrees = [lInputTree, iInputTree, wInputTree];
    let outDataTrees = [];

    Geometry.makeMultipleBranches(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      var path = outDataTrees[0].paths[i];
      var list = outDataTrees[0].branches[i];
      var listcopy = [...list];

      var indexes = outDataTrees[1].branches[i];
      var wrap = outDataTrees[2].branches[i][0];
      // outTree.addEmpty(path)

      if (wrap) {
        indexes = indexes.map(x => x % list.length);
      } else {
        indexes = indexes.map(x => Math.min(x, list.length - 1));
      }

      indexes.sort(function (a, b) {
        return b - a;
      });

      for(let j = 0; j < indexes.length; j++){
        var index = indexes[j];
        listcopy.splice(index, 1);
      }

      path.add(0);

      let addCount = 0;
      for (let j = 0; j < listcopy.length; j++) {
        var item = listcopy[j];
        outTree.add(item, path);
        addCount += 1;
      }

      if (addCount === 0) {
        outTree.addEmpty(path);
      }
    }
    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/CullIndex.js